import fetch from 'auth/FetchInterceptor'

const contratoService = {}

contratoService.all = function () {
  return fetch({
    url: '/contrato/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

contratoService.paginated = function ({ page = 0, size = 10, nomeCliente = '', cpfCnpjCliente = '', placaCliente = '', imei = '' } = {}) {
  return fetch({
    url: '/contrato',
    method: 'get',
    params: { page, size, nomeCliente, cpfCnpjCliente, placaCliente, imei },
  })
}

contratoService.getTestemunha = function () {
  return fetch({
    url: '/testemunha',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

contratoService.saveTestemunha = function (data) {
  return fetch({
    url: '/testemunha',
    method: 'post',
    data: data
  })
}

contratoService.id = function (data) {
  return fetch({
    url: `/contrato/${data}/id`,
    method: 'get',
    data: data
  })
}

contratoService.save = function (data) {
  return fetch({
    url: '/contrato',
    method: 'post',
    data: data
  })
}

contratoService.inativar = function (data) {
  return fetch({
    url: `/contrato/${data}/inativar`,
    method: 'put',
    data: data
  })
}

contratoService.criarBoleto = function (data) {
  return fetch({
    url: `/contrato/${data}/criar-boleto`,
    method: 'post',
    data: data
  })
}

contratoService.atualizarContrato = function (data) {
  return fetch({
    url: `/contrato/${data}/atualizar`,
    method: 'post',
    data: data
  })
}

contratoService.criarJuridico = function (data) {
  return fetch({
    url: `/contrato/${data}/criar-contrato-juridico`,
    method: 'post',
    data: data
  })
}

contratoService.adicionarVeiculo = function (contratoId, data) {
  return fetch({
    url: `/contrato/${contratoId}/veiculo`,
    method: 'post',
    data: data
  })
}

contratoService.removerVeiculo = function (contratoId, veiculoId) {
  return fetch({
    url: `/contrato/${contratoId}/veiculo/${veiculoId}`,
    method: 'delete'
  })
}

contratoService.trocarVeiculo = function (contratoId, veiculoIdAtual, data) {
  return fetch({
    url: `/contrato/${contratoId}/veiculo/${veiculoIdAtual}/trocar`,
    method: 'put',
    data: data
  })
}

contratoService.listarVeiculos = function (contratoId) {
  return fetch({
    url: `/contrato/${contratoId}/veiculos`,
    method: 'get'
  })
}

contratoService.aplicarAditivo = function (contratoId, data) {
  return fetch({
    url: `/contrato/${contratoId}/aditivo`,
    method: 'post',
    data: data
  })
}

contratoService.listarDigitais = function (contratoId) {
  return fetch({
    url: `/contrato/${contratoId}/digitais`,
    method: 'get'
  })
}

contratoService.aditivosPendentes = function (contratoId) {
  return fetch({
    url: `/contrato/${contratoId}/aditivo/pendentes`,
    method: 'get'
  })
}

contratoService.regerarDigital = function (contratoDigitalId) {
  return fetch({
    url: `/contrato-digital/${contratoDigitalId}/regerar`,
    method: 'post'
  })
}

contratoService.exportarCSV = function () {
  return fetch({
    url: '/contrato/exportar-csv',
    method: 'get',
    responseType: 'blob',
  })
}

contratoService.exportarAcaoJudicialCSV = function () {
  return fetch({
    url: '/contrato/exportar-csv-acao-judicial',
    method: 'get',
    responseType: 'blob',
  })
}

export default contratoService